import React, { useState } from "react";
import { FaUserGroup, FaClock, FaCubes, FaHeadset, FaCode } from "react-icons/fa6";
import { Container } from "../home/ui";

// Left artwork (developer at a desk with screens). Put the file at public/img/software-why.jpg
// (or change the path). Until it exists, a soft placeholder is shown.
const whyImg = "/img/software-why.jpg";

const points = [
  { icon: FaUserGroup, title: "Expert Team", text: "Skilled and experienced developers", tone: "bg-[#E8F0FF] text-[#1E6BFF]" },
  { icon: FaClock, title: "On-Time Delivery", text: "We value your time", tone: "bg-[#F0E9FF] text-[#7C3AED]" },
  { icon: FaCubes, title: "Scalable Solutions", text: "Built for future growth", tone: "bg-[#E6F7EE] text-[#16A34A]" },
  { icon: FaHeadset, title: "Ongoing Support", text: "Dedicated support team", tone: "bg-[#F0E9FF] text-[#7C3AED]" },
];

const fadeX = "linear-gradient(to right, transparent 0%, #000 6%, #000 92%, transparent 100%)";
const fadeY = "linear-gradient(to bottom, transparent 0%, #000 6%, #000 94%, transparent 100%)";
const edgeFade = {
  WebkitMaskImage: `${fadeX}, ${fadeY}`,
  WebkitMaskComposite: "source-in",
  maskImage: `${fadeX}, ${fadeY}`,
  maskComposite: "intersect",
};

const SoftWhyChoose = () => {
  const [failed, setFailed] = useState(false);

  return (
    <section className="bg-white py-[44px] lg:py-[60px]">
      <Container className="max-w-[1320px]">
        <div className="grid items-center gap-[36px] lg:grid-cols-2 lg:gap-[48px]">
          <div>
            {failed ? (
              <div className="flex aspect-[16/10] w-full items-center justify-center rounded-[28px] bg-gradient-to-br from-[#E8EDFF] to-[#F2ECFF] text-[72px] text-[#5B47F0]">
                <FaCode />
              </div>
            ) : (
              <img
                src={whyImg}
                onError={() => setFailed(true)}
                alt="Developer working at a desk with multiple screens"
                className="h-auto w-full select-none object-contain"
                style={edgeFade}
              />
            )}
          </div>

          <div>
            <span className="inline-block rounded-full bg-[#E6EEFF] px-[14px] py-[5px] text-[12px] font-semibold uppercase tracking-[0.04em] text-[#1E4DFF]">
              Why Choose Us
            </span>
            <h2 className="mt-[14px] text-[28px] font-extrabold leading-[1.2] tracking-tight text-[#0B0D2C] sm:text-[34px] xl:text-[clamp(28px,2.2vw,38px)]">
              Your Trusted Software
              <br />
              Development Partner
            </h2>
            <p className="mt-[14px] max-w-[540px] text-[15px] leading-[1.6] text-slate-600 sm:text-[16px]">
              We combine technical expertise, industry experience, and a client-first approach to deliver digital solutions that
              create real business value.
            </p>
            <div className="mt-[28px] grid gap-x-[32px] gap-y-[24px] sm:grid-cols-2">
              {points.map((p) => (
                <div key={p.title} className="flex items-start gap-[14px]">
                  <span className={`inline-flex h-[48px] w-[48px] shrink-0 items-center justify-center rounded-full text-[20px] ${p.tone}`}>
                    <p.icon />
                  </span>
                  <div>
                    <h3 className="text-[15.5px] font-bold text-[#0B0D2C]">{p.title}</h3>
                    <p className="mt-[4px] text-[14px] text-slate-500">{p.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default SoftWhyChoose;
